import React, { useEffect, useMemo, useState } from "react";
import { RadioGroup } from "@headlessui/react";
import { TransProps } from "@lingui/react";
import IconWithTitleByHover from "components/UI/IconWithTitleByHover/IconWithTitleByHover";

export type typeRadioGroupItem = {
  id: string;
  name: React.ReactElement<TransProps>;
  suggest?: React.ReactElement<TransProps>;
  suggestIcon?: { icon: (props: React.ComponentProps<"svg">) => JSX.Element };
};
export type typeRadioGroupSettings = {
  variant?: string;
  valuesList: typeRadioGroupItem[];
  valueId: string | number | null;
  setIdValue: React.Dispatch<React.SetStateAction<any>>;
  label?: React.ReactElement<TransProps>;
  selectDefault?: number;
  labelClassname?: string;
  disabled?: boolean;
};

// @ts-ignore
function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export const RadioGroupComponent: React.FC<typeRadioGroupSettings> = ({
  label,
  valueId,
  setIdValue,
  valuesList,
  labelClassname,
  disabled,
}) => {
  const labelStyles = [
    "block mb-3 text-sm font-medium text-gray-700 ",
    labelClassname,
  ].join(" ");
  let newValuesList = useMemo(() => [...valuesList], [valuesList]);

  const [selected, setSelected] = useState(newValuesList[0]);

  useEffect(() => {
    const selectedItemIndex = newValuesList.findIndex(
      (item) => item.id === valueId,
    );
    if (selectedItemIndex >= 0) setSelected(newValuesList[selectedItemIndex]);
    // eslint-disable-next-line
  }, [valueId, valuesList]);

  useEffect(() => {
    setIdValue(selected.id);
    // eslint-disable-next-line
  }, [selected]);

  return (
    <div>
      <RadioGroup value={selected} onChange={setSelected}>
        {label && (
          <RadioGroup.Label className={labelStyles} role={"div"}>
            {label}
          </RadioGroup.Label>
        )}
        <div className="bg-white rounded-md ">
          {newValuesList.map((setting, settingIdx) => (
            <RadioGroup.Option
              key={setting.id}
              value={setting}
              disabled={disabled}
              className={({ checked }) =>
                classNames(
                  settingIdx === 0 ? "rounded-tl-md rounded-tr-md" : "",
                  settingIdx === newValuesList.length - 1
                    ? "rounded-bl-md rounded-br-md"
                    : "",
                  checked
                    ? "bg-primary-50 border-primary-200 z-10 "
                    : "border-gray-200",
                  disabled ? "bg-gray-200 opacity-50" : "",
                  "relative border p-4 flex cursor-pointer focus:outline-none",
                )
              }
            >
              {({ active, checked }) => (
                <>
                  <span
                    className={classNames(
                      checked
                        ? "ring-1 ring-offset-2 bg-primary-600 border-transparent"
                        : "bg-white border-gray-300",
                      active ? "ring-2 ring-offset-2 ring-primary-500 " : "",
                      "h-3 w-3 mt-1 cursor-pointer rounded-full border flex items-center justify-center",
                    )}
                    aria-hidden="true"
                  >
                    <span className="rounded-full bg-white w-1 h-1" />
                  </span>
                  <div className="ml-3 flex flex-col">
                    <RadioGroup.Label
                      as="div"
                      className={classNames(
                        checked ? "text-primary-900" : "text-gray-900",
                        "flex flex-nowrap gap-2 text-sm font-medium",
                      )}
                    >
                      {setting.name}
                      {setting.suggest && (
                        <IconWithTitleByHover
                          // iconElement={ setting.suggestIcon ? setting.suggestIcon : { icon: QuestionMarkCircleIcon } }
                          title={setting.suggest}
                        />
                      )}
                    </RadioGroup.Label>
                  </div>
                </>
              )}
            </RadioGroup.Option>
          ))}
        </div>
      </RadioGroup>
    </div>
  );
};
